export default __webpack_public_path__ + "static/media/eudelegationH_light.337326c8.png";